import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventosProvider } from '../../providers/eventos';
import { Componentes } from '../../providers/componentes';
import { EventoDetalhesPage } from '../../pages/evento-detalhes/evento-detalhes'
import { LocalStorageProvider } from '../../providers/local-storage';

@Component({
  selector: 'page-eventos',
  templateUrl: 'eventos.html',
})
export class EventosPage {

  items: any = [];
  loading: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public componentes: Componentes,
    public storage: LocalStorageProvider,
    public eventosService: EventosProvider) {
  }

  ionViewDidLoad() {
    this.storage.storageGet('eventos').then(
      data => {
        if (data) {
          let dados = JSON.parse(data);
          this.items = dados['eventos'];
        } 
        this.loadEventos();
      }, err => { }
    );
  }

  loadEventos() {
    this.eventosService.refresh();
    this.eventosService.getEventos().then(
      data => {
        this.items = data['eventos'];
        this.loading = false;
      }, error => {
        this.componentes.apresentaToast('Não foi possível atualizar os eventos. Verifique a sua conexão e texte novamente.');
        this.loading = false;
      }
    )
  }

  doRefresh(refresher) {
    this.eventosService.refresh();
    this.eventosService.getEventos().then(
      data => {
        refresher.complete();
        this.items = data['eventos'];
      }
    )
  }

  eventoDetalhes(id) {
    this.navCtrl.push(EventoDetalhesPage, { id: id });
  }
}



// WEBPACK FOOTER //
// ./src/pages/eventos/eventos.ts